import { NgModule } from "@angular/core";
import { AlertFacadeService } from './services/alert-facade.service';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [],
    entryComponents: [],
    imports: [
        CommonModule,
        ToastrModule.forRoot()
    ],
    providers: [AlertFacadeService]
  })
export class AlertFacadeServiceModule { }